import updateCart from './update-popup-cart.js';
import initMap from './restaurants-map';
import { applyPromoFromBanner } from './helpers';
import { fetchData, postData } from './fetch';

import './update-product-quantity';
import './promo-logic';

window.addEventListener('load', () => {
  const mapWrapper = document.querySelector('.map-wrapper');
  const bannerSwiper = document.querySelector('.banner-swiper');
  const newProductsSwiper = document.querySelector('.new-products-swiper');
  const popularProductsSwiper = document.querySelector(
    '.popular-products-swiper',
  );
  const sliderStateBtns = document.querySelectorAll('.slider-state-btn');
  const productsSliders = document.querySelectorAll('.products-slider');
  const addPromoProductBtn = document.querySelectorAll('.add-promo-product');
  const applyPromoBtn = document.querySelectorAll('.apply-promo');
  const promoSetButton = document.querySelectorAll('.add-set-product');

  if (bannerSwiper) {
    new Swiper('.banner-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 400,
      autoplay: {
        delay: 6000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    const popupButtons = bannerSwiper.querySelectorAll(
      '.swiper-slide .slider-popup-btn',
    );

    if (popupButtons) {
      [].forEach.call(popupButtons, (btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const { id } = btn.dataset;

          if (document.getElementById(id)) {
            document.getElementById(id).classList.add('active');
          }
        });
      });
    }
  }

  if (sliderStateBtns) {
    [].forEach.call(sliderStateBtns, (btn) => {
      btn.addEventListener('click', () => {
        const { slider } = btn.dataset;

        [].forEach.call(sliderStateBtns, (button) =>
          button.classList.remove('active'),
        );

        btn.classList.add('active');

        if (productsSliders) {
          [].forEach.call(productsSliders, (slider) =>
            slider.classList.remove('active'),
          );
        }

        if (
          document.querySelector(`.products-slider[data-slider="${slider}"]`)
        ) {
          document
            .querySelector(`.products-slider[data-slider="${slider}"]`)
            .classList.add('active');
        }
      });
    });
  }

  if (newProductsSwiper) {
    new Swiper('.new-products-swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 28,
      loop: false,
      speed: 400,
      breakpoints: {
        520: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          speed: 600,
        },
        700: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          speed: 800,
        },
        895: {
          allowTouchMove: true,
        },
        1145: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        1440: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  if (popularProductsSwiper) {
    new Swiper('.popular-products-swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 28,
      loop: false,
      speed: 400,
      breakpoints: {
        520: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          speed: 600,
        },
        700: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          speed: 800,
        },
        1145: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        1440: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  if (mapWrapper) {
    const getRestaurants = async () => {
      const response = await fetchData('/restaurants/map-list');

      if (response) {
        initMap(response.restaurants, response.currentRegionCoord);
      }
    };

    getRestaurants();
  }

  if (addPromoProductBtn) {
    [].forEach.call(addPromoProductBtn, (btn) => {
      btn.addEventListener('click', async () => {
        const { id } = btn.dataset;

        const body = {
          id,
          quantity: 1,
        };

        btn.textContent = 'Загрузка...';
        btn.classList.add('disabled');

        const response = await postData('/cart', body);

        if (response) {
          if (response.statusCode === 200) {
            const productBuyWrapper = document.querySelectorAll(
              `.buy-wrapper[data-id="${id}"]`,
            );
            const parentElement = btn.closest('.sale-popup-wrapper');

            btn.classList.remove('disabled');
            btn.classList.add('added');
            btn.textContent = 'Добавлено';

            if (parentElement) {
              setTimeout(() => {
                parentElement.classList.remove('active');
                btn.classList.remove('added');
                btn.textContent = 'Добавить в корзину';
              }, 2000);
            }

            if (productBuyWrapper) {
              [].forEach.call(productBuyWrapper, (wrapper) => {
                const buyBtn = wrapper.querySelector('.buy-button');
                const countBtn = wrapper.querySelector('.count-button');

                if (buyBtn) {
                  buyBtn.classList.add('hidden');
                }

                if (countBtn) {
                  const countInput = countBtn.querySelector('.count-input');

                  if (countBtn.classList.contains('visible')) {
                    countInput.value = parseInt(countInput.value, 10) + 1;
                  } else {
                    countBtn.classList.add('visible');
                  }
                }
              });
            }

            updateCart(response.data, response.data.additional);
          } else {
            btn.textContent = 'Добавить в корзину';
          }
        }
      });
    });
  }

  if (applyPromoBtn) {
    [].forEach.call(applyPromoBtn, (btn) => {
      btn.addEventListener('click', () => {
        const { number } = btn.dataset;

        const body = {
          promo: number,
          hidden: true,
        };

        const parentElement = btn.closest('.sale-popup');

        const cookies = document.cookie.split(';');
        let cartId;

        const cartIdCookie = cookies.find((cookie) =>
          cookie.includes('cartId'),
        );

        if (cartIdCookie) {
          cartId = cartIdCookie.split('=');
        }

        if (!cartId) {
          if (parentElement) {
            const errorText = parentElement.querySelector('.error-text');

            errorText.textContent =
              'Невозможно применить акцию. Ваша корзина пуста';
          }
        } else {
          btn.textContent = 'Загрузка...';
          btn.classList.add('disabled');

          applyPromoFromBanner(body, btn);
        }
      });
    });
  }

  if (promoSetButton) {
    [].forEach.call(promoSetButton, (btn) => {
      const { id } = btn.dataset;

      btn.addEventListener('click', () => {
        const parentElement = btn.closest('.sale-popup-wrapper');

        if (parentElement) {
          parentElement.classList.remove('active');
        }

        if (document.getElementById(`set-${id}`)) {
          document.getElementById(`set-${id}`).classList.add('active');
        }
      });
    });
  }
});
